import { IconCalendarMonth, IconChartBar, IconCopy, IconHandClick, IconRefreshDot, IconToggleLeftFilled, IconToggleRightFilled } from '@tabler/icons-react'
import React, { useEffect, useState } from 'react'
import { Link, useLocation, useParams } from 'react-router-dom'
import { toast } from 'sonner'
import { getApi, postApi } from '../../api/call.api'
import { urlApi } from '../../api/url.api'
import IconButton from '../../components/Buttons/IconButton'
import ConfirmationModal from '../../components/ConfirmationModal/ConfirmationModal'
import TableComponent from '../../components/DataTable/TableComponent'
import DateRange from '../../components/DateRange/DateRange'
import DropDown from '../../components/DropDown/DropDown'
import SearchComponent from '../../components/Search/SearchComponent'
import Layout from '../../layout/Layout'
import { loadingHide, loadingShow } from '../../loadingUi/loading.controller'
import { dateIntoYYYY_MM_DD, dateTimeConverter, formatDateToShortMonthDayYear } from '../../utils/dateTimeConverter'
import TablePreview from './Components/TablePreview'

const AllPages = () => {
    const [activePage, setActivePage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [tableData, setTableData] = useState({
        data: [],
        totalCount: 0
    });
    const [searchData, setSearchData] = useState('');
    const [statusFilter, setStatusFilter] = useState(null);
    const [date, setDate] = useState({ startDate: '', endDate: '' });
    const [sortFilter, setSortFilter] = useState(null);

    const { userId } = useParams();
    const { state: userData } = useLocation();

    const statusList = [
        {
            id: null,
            name: "All"
        }, {
            id: 1,
            name: "Active"
        }, {
            id: 2,
            name: "Inactive"
        }
    ]

    const sortFilterList = [
        {
            id: null,
            name: "All"
        }, {
            id: 'linkClicks,ASC',
            name: "Link Clicks L-H"
        }, {
            id: 'linkClicks,DESC',
            name: "Link Clicks H-L"
        }, {
            id: 'uniqueLinkClicks,ASC',
            name: "Unique Clicks,L-H"
        }, {
            id: 'uniqueLinkClicks,DESC',
            name: "Unique Clicks,H-L"
        }
    ]

    function handlePageChange(page) {
        setActivePage(page);
    }

    function handlePerRowsChange(newPerPage, page) {
        setActivePage(page);
        setPerPage(newPerPage)
    }

    async function getList() {
        loadingShow();
        let postData = {
            "startDate": dateIntoYYYY_MM_DD(date.startDate),
            "endDate": dateIntoYYYY_MM_DD(date.endDate)
        }
        let statusFilterLocal = statusList?.find(item => item?.name == statusFilter);
        let sortFilterLocal = sortFilterList?.find(item => item?.name == sortFilter);
        let url = `${urlApi.getPagesList}?page=${activePage}&limit=${perPage}`;
        if (searchData) {
            url += `&search=${searchData}`
        }
        if (statusFilterLocal?.id) {
            url += `&filterByStatus=${statusFilterLocal ? statusFilterLocal?.id : null}`
        }
        if (sortFilterLocal?.id) {
            url += `&sort=${sortFilterLocal ? sortFilterLocal?.id : null}`
        }
        if (userId) {
            url += `&userId=${userId}`;
        }
        let resp = await postApi((postData?.startDate ? postData : {}), url);
        loadingHide();
        if (resp.responseCode === 200) {
            setTableData({
                data: resp.data?.items,
                totalCount: resp.data?.count
            })
        } else {
            setTableData({
                data: [],
                totalCount: 0
            });
            toast.error(resp.message);
        }
    }

    useEffect(() => {
        // if (accessCheck(accessKeys.getUserList)) {
        getList();
        // }
    }, [activePage, perPage, searchData, statusFilter, userId, sortFilter, date])

    async function updateStatus(id, status) {
        loadingShow();
        let resp = await getApi(`${urlApi.updateLinkStatus}${id}/${status}`);
        loadingHide();
        if (resp.responseCode === 200) {
            toast.success(resp.message);
            getList();
        } else {
            toast.error(resp.message);
        }
    }

    function onStatusFilterChange(status) {
        setActivePage(1);
        setStatusFilter(status)
    }

    function onSortFilterChange(filter) {
        setActivePage(1);
        setSortFilter(filter)
    }

    function onDateChange(p) {
        let newDate = { startDate: p.startDate._d, endDate: p.endDate._d }
        setActivePage(1);
        setDate(newDate)
    }

    function resetAll() {
        setActivePage(1);
        setPerPage(10);
        setSearchData(null);
        setStatusFilter(null);
        setSortFilter(null);

        setDate({ startDate: '', endDate: '' });
        document.getElementById("user-table-search").value = ""
    }

    function onCopy(copyText) {
        navigator.clipboard
            .writeText(copyText)
            .then(() => {
                toast.success("copied");
            })
            .catch(() => {
                toast.error("something went wrong");
            });
    }

    const columns = [
        { name: "Sl. No", center: "true", width: "60px", selector: (row) => row?._id, cell: (row, index) => (activePage - 1) * perPage + (index + 1) },
        {
            name: "Page", selector: (row) => row?.channel_name, grow: 3.2, cell: (row) => (
                <div className='flex py-2 gap-3 items-center'>
                    <div className=''>
                        <TablePreview pageData={row?.pageData} />
                    </div>
                    <div className="text-left">
                        <p className="!mb-1 font-medium rounded-full px-2 border text-center w-max border-primary text-xs text-[var(--black)] cursor-pointer" onClick={() => onCopy(row?._id)}>{row?._id}</p>
                        <p className="mb-0.5 font-semibold text-sm text-[var(--black)]">{row?.linkName}</p>
                        <Link to={row?.shortLink} target='_blank'> <p className="mb-0.5 font-semibold text-primary text-sm">{row?.shortLink}</p></Link>
                        <Link to={row?.mainLink} target='_blank'><p className="mb-0.5 text-xs italic text-[var(--black)]">{row?.mainLink}</p></Link>
                        <div className="flex gap-2 flex-wrap">
                            <p className={`font-semibold text-[10px] ${row?.linkClicks > 0 ? 'text-green-500' : 'text-[#BDBDBD]'} inline-flex items-center gap-1 mb-0`}> <span> <IconChartBar size={16} /> </span> {row?.linkClicks ?? "0"} engagements</p>
                            <p className={`font-semibold text-[10px] ${row?.uniqueLinkClicks > 0 ? 'text-green-500' : 'text-[#BDBDBD]'} inline-flex items-center gap-1 mb-0`}> <span> <IconHandClick size={16} /> </span> {row?.uniqueLinkClicks ?? "0"} unique clicks</p>
                            <p className="font-semibold text-[10px] text-[#BDBDBD] inline-flex items-center gap-1 mb-0"> <span> <IconCalendarMonth size={16} /> </span> {formatDateToShortMonthDayYear(row?.createdAt)}</p>
                        </div>
                    </div>
                </div>
            )
        }, {
            name: "User", center: "true", grow: 1, selector: (row) => row?.category, cell: (row) => (
                <Link to={'/user/' + row?.userId} className="text-center">
                    <img src={row?.userProfilePic} alt="" className='h-8 rounded-full aspect-square object-cover bg-slate-500 mx-auto' />
                    <p className="mb-0.5 font-semibold text-sm text-[var(--black)]">{row?.userName}</p>
                </Link>
            )
        }, {
            name: "Action", center: "true", grow: 1, selector: (row) => row?.category, cell: (row) => (
                <div className="flex gap-2 items-center flex-wrap justify-center">
                    <IconButton icon={< IconCopy size={16} />} text={"Copy"} onClickFunction={() => onCopy(row?.shortLink)} />
                    <Link to={"/page-details"} state={row} className='no-underline'>  <IconButton icon={< IconChartBar size={16} />} text={"Details"} /></Link>
                </div>
            )
        },
        {
            name: "Created", center: "true", selector: (row) => row?.createdAt, cell: (row) =>
                <p>{dateTimeConverter(row?.createdAt)}</p>
        },
        {
            name: "Status", center: "true", selector: (row) => row?.status, width: "60px", cell: (row) =>
                // accessCheck(accessKeys.updateUserStatus) ?
                <ConfirmationModal
                    buttonComponent={row?.status == 1 ? <IconToggleRightFilled className='text-green-600 cursor-pointer transition-all' /> : <IconToggleLeftFilled className='text-red-700 cursor-pointer transition-all' />}
                    confirmationText={`Are You Sure Want To ${row?.status == 1 ? 'Deactivate' : "Activate"} this Page ?`}
                    onConfirm={() => updateStatus(row?._id, row?.status == 1 ? 2 : 1)}
                />
            //  :   row?.status == 1 ? <IconToggleRightFilled className='text-green-600 transition-all' /> : <IconToggleLeftFilled className='text-red-700 transition-all' />
        },
    ];
    return (
        <Layout>
            <div className='flex items-center mb-3 justify-between'>
                <h1 className='text-xl font-bold text-gray-600'>Pages {userData?.name && ('of ' + userData?.name)}</h1>
            </div>

            {/* {accessCheck(accessKeys.getUserList) && */}
            <div className='flex mb-3 justify-between items-center flex-wrap gap-2'>
                <SearchComponent onClear={() => { document.getElementById("user-table-search").value = ""; setSearchData('') }} inputValue={searchData}
                    onSearch={() => { setSearchData(document.getElementById("user-table-search")?.value); setActivePage(1) }} inputId='user-table-search' placeholder={"Link Code/Short URL/Main URL"} />
                <div className='ms-auto'>
                </div>
                <DateRange onApplyClick={(date) => onDateChange(date)} date={date} cssClass={'ms-auto'} />
                <DropDown title={"Status"} list={statusList?.map(item => item?.name)} defaultValue={statusFilter} onSelect={(name) => onStatusFilterChange(name)} />
                <DropDown title={"Sort"} list={sortFilterList?.map(item => item?.name)} defaultValue={sortFilter} onSelect={(name) => onSortFilterChange(name)} />
                <div className='ms-[auto] md:ms-0'>
                    <IconRefreshDot className='cursor-pointer text-[var(--secondary-gradient-1)]' onClick={() => resetAll()} />
                </div>
            </div>
            {/* } */}
            <TableComponent
                columns={columns}
                data={tableData.data}
                totalRows={tableData.totalCount}
                isPagination={true}
                handlePageChange={(e) => handlePageChange(e)}
                handlePerRowsChange={(newPerPage, page) => handlePerRowsChange(newPerPage, page)} />

        </Layout>
    )
}

export default AllPages